import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const MiniOptions = ({setOption, option, options}) => { 
    return (
        <div className="mini-options">
          {options.map(
              (opt, i) =>
                  <div
                    key={i}
                    onClick={() => setOption(opt === option ? undefined : opt)}
                    className={option === opt ? "selected option" :"option"}>{opt}</div>)}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MiniOptions);
